<template>
  <div>
  <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
  <Filter />
<div class="container py-4 px-4">
  <div class="d-flex justify-content-center">
    <div class="form-check form-check-inline" :class="{ 'mb-3': isDateRangeChecked, 'mb-4': !isDateRangeChecked }">
    <input class="form-check-input shadow-none" type="radio" name="inlineRadioOptions" id="inlineRadio1" :value=1
      checked v-model="selectedMoistureOption" @change="handleselectedMoistureOption">
    <label class="form-check-label custom-label" for="inlineRadio1">Flow / Level</label>
  </div>
  <div class="form-check form-check-inline py-0" :class="{ 'mb-3': isDateRangeChecked, 'mb-4': !isDateRangeChecked }">
    <input class="form-check-input shadow-none" type="radio" name="inlineRadioOptions" id="inlineRadio1" :value=0
      v-model="selectedMoistureOption" @change="handleselectedMoistureOption">
    <label class="form-check-label custom-label" for="inlineRadio1">Moisture Adj. Flow</label>
  </div>
  </div>
  <div class="button-container d-flex justify-content-center mb-4" v-if="!isDateRangeChecked">
    <label for="time-range-select" class="custom-label d-flex  justify-content-center  align-items-center me-1">Root:
    </label>
    <div class="form-group me-2">
      <select class="form-select form-select-sm form-control shadow-none custom-input custom-dropdown"
        id="autoSizingSelect" v-model="selectedRoot" @change="onRootChange">
        <option value="" disabled>Select Option</option>
        <option v-for="root in roots" :key="root.root" :value="root.root">{{ root.root }}</option>
      </select>
    </div>
   
    <label for="time-range-select" class="custom-label d-flex  justify-content-center  align-items-center me-1">Folder Name:
    </label>
    <div class="form-group me-2">
      <select class="form-select form-select-sm form-control shadow-none custom-input custom-dropdown"
        id="autoSizingSelect" v-model="selectedFolder" @change="onFolderChange">
        <option value="" disabled>Select Option</option>
        <option v-for="folder in folders" :key="folder.folder" :value="folder.folder">{{ folder.folder }}</option>
      </select>
    </div>
    <label for="time-range-select" class="custom-label d-flex  justify-content-center  align-items-center me-1">File:
    </label>
    <div class="form-group me-2">
      <select class="form-select form-select-sm form-control shadow-none custom-input custom-dropdown"
        id="autoSizingSelect" v-model="selectedFile" @change="onFileChange">
        <option value="" disabled>Select Option</option>
        <option v-for="file in files" :key="file.filename" :value="file.filename">{{ file.filename }}</option>
      </select>
    </div> 
  </div>
  <div class="button-container d-flex justify-content-center "  :class="{ 'mb-3': isDateRangeChecked }">
    <label v-if="!isDateRangeChecked" for="time-range-select" class="custom-label d-flex  justify-content-center  align-items-center me-1">Hub:
    </label>
    <div v-if="!isDateRangeChecked" class="form-group me-2">
      <select class="form-select form-select-sm form-control shadow-none custom-input custom-dropdown"
        id="autoSizingSelect" v-model="selectedHub" @change="onHubChange">
        <option value="" disabled>Select Option</option>
        <option v-for="hub in hubs" :key="hub.uuid" :value="hub.uuid">{{ hub.name }}</option>
      </select>
    </div>
    <label v-if="!isDateRangeChecked" for="time-range-select"
      class="custom-label d-flex  justify-content-center  align-items-center me-1">Controller: </label>
    <div v-if="!isDateRangeChecked" class="form-group me-2">
      <select class="form-select form-control shadow-none form-select-sm custom-input custom-dropdown"
        id="autoSizingSelect" v-model="selectedController" @change="onControllerChange">
        <option value="" disabled>Select Option</option>
        <option v-for="comp in components" :key="comp.uuid" :value="comp.uuid">{{ comp.name }}</option>
      </select>
    </div>
    <label v-if="!isDateRangeChecked" for="time-range-select"
      class="custom-label d-flex  justify-content-center  align-items-center me-1">Device: </label>
    <div v-if="!isDateRangeChecked"
      :class="{ 'form-group': true, 'me-2': selectedMoistureOption === 0, 'me-3': selectedMoistureOption === 1 }">
      <select class="form-select form-control shadow-none form-select-sm custom-input custom-dropdown"
        id="autoSizingSelect" v-model="selectedDevice">
        <option value="" disabled>Select Option</option>
        <option v-for="device in devices" :key="device.uuid" :value="device.uuid">{{ device.name }}</option>
      </select>
    </div>
    <label  for="time-range-select" class="custom-label d-flex  justify-content-center  align-items-center me-1"
      v-if="selectedMoistureOption === 0 && !isDateRangeChecked">Moisture: </label>
    <div class="form-group me-3" v-if="selectedMoistureOption === 0 && !isDateRangeChecked">
      <select class="form-select form-control shadow-none form-select-sm custom-input custom-dropdown"
        id="autoSizingSelect" v-model="selectedMoisture" >
        <option v-for="Moisture in Moistures" :key="Moisture.name" :value="parseFloat(Moisture.name).toFixed(1)">{{
          parseFloat(Moisture.name).toFixed(1) }}</option>
      </select>
    </div>
   
    <div class="form-group me-3" v-if="!isDateRangeChecked">
      <button type="submit" class="btn btn-sm active device-graph-button"
       @click="fetchGraphData" :disabled="!selectedRoot || !selectedFolder || !selectedFile 
       || !selectedHub || !selectedController || !selectedDevice">SUBMIT</button>
    </div>

    <div class="form-group form-check">
          <input type="checkbox" class="form-check-input shadow-none" id="exampleCheck1" v-model="isDateRangeChecked"
          @change="handleDateRangeChange">
          <label class="form-check-label custom-label" for="exampleCheck1">Date Range</label>
        </div>
  </div>
  <div class="button-container d-flex justify-content-center" v-if="isDateRangeChecked">
    <label for="time-range-select" class="custom-label d-flex  justify-content-center  align-items-center me-1">Hub:
    </label>
    <div class="form-group me-2">
      <select class="form-select form-select-sm form-control shadow-none custom-input custom-dropdown"
        id="autoSizingSelect" v-model="selectedHub" @change="onHubChange">
        <option value="" disabled>Select Option</option>
        <option v-for="hub in hubs" :key="hub.uuid" :value="hub.uuid">{{ hub.name }}</option>
      </select>
    </div>
    <label for="time-range-select"
      class="custom-label d-flex  justify-content-center  align-items-center me-1">Controller: </label>
    <div class="form-group me-2">
      <select class="form-select form-control shadow-none form-select-sm custom-input custom-dropdown"
        id="autoSizingSelect" v-model="selectedController" @change="onControllerChange">
        <option value="" disabled>Select Option</option>
        <option v-for="comp in components" :key="comp.uuid" :value="comp.uuid">{{ comp.name }}</option>
      </select>
    </div>
    <label for="time-range-select"
      class="custom-label d-flex  justify-content-center  align-items-center me-1">Device: </label>
    <div class="me-2">
      <select class="form-select form-control shadow-none form-select-sm custom-input custom-dropdown"
        id="autoSizingSelect" v-model="selectedDevice" >
        <option value="" disabled>Select Option</option>
        <option v-for="device in devices" :key="device.uuid" :value="device.uuid">{{ device.name }}</option>
      </select>
    </div>
    <label  for="time-range-select" class="custom-label d-flex  justify-content-center  align-items-center me-1"
      v-if="selectedMoistureOption === 0">Moisture: </label>
    <div class="form-group me-2" v-if="selectedMoistureOption === 0">
      <select class="form-select form-control shadow-none form-select-sm custom-input custom-dropdown"
        id="autoSizingSelect" v-model="selectedMoisture" >
        <option v-for="Moisture in Moistures" :key="Moisture.name" :value="parseFloat(Moisture.name).toFixed(1)">{{
          parseFloat(Moisture.name).toFixed(1) }}</option>
      </select>
    </div>
    <div class="d-flex justify-content-center align-items-center" >
          <label for="start-date" class="custom-label me-1">Start Date:</label>
          <div class="form-group me-2">
            <input id="start-date" type="date" class="form-control shadow-none form-select-sm custom-input"
            v-model="startdate">
          </div>
        </div>
        <label  for="time-range-select" class="custom-label d-flex  justify-content-center  align-items-center me-1">Month:
      </label>
      <div class="form-group me-3">
        <select class="form-select form-select-sm form-control shadow-none custom-input custom-dropdown"
          id="autoSizingSelect" v-model="daterange">
          <option v-for="month in monthOptions" :key="month" :value="month">{{ month }}</option>
        </select>
      </div>
    <div class="form-group me-3">
      <button type="submit" class="btn btn-sm active device-graph-button"
       @click="fetchGraphData" :disabled="!selectedHub || !selectedController || !selectedDevice || !startdate">SUBMIT</button>
    </div>
  </div>
  <div class="device-graph">
    <div v-if="loading" class="loading-indicator spinner-border spinner-border"></div>
    <div class="no-record-device-graph">{{ noRecordFound }}</div>
    <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
  </div>

</div>
</div>
</template>
<script>
import Header from '@/components/Header.vue';
import Filter from '@/components/Filter.vue';
import { ddFile, ddFolder, ddRoot, ddHub, ddController,ddDevice, getDeviceGraphData } from '@/http/archival/device-graph.http';

export default {
name: 'deviceGraph',
components: {
Header,
Filter,
},
data() {
return {
  breadcrumsfirst: "Archival",
  breadcrumslast: "Device Graph",
  loading: false,
  noRecordFound: '',
  isTimer: 0,
  selectedHub: '',
  selectedRoot:'',
  selectedDevice: '',
  selectedController: '',
  selectedFolder: '',
  selectedFile:'',
  selectedMoisture: 0.5,
  isDateRangeChecked: 0,
  startdate: '',    
  apiResponse: null, // Initialize apiResponse as null
  monthOptions: ['1M', '3M', '6M'],
  daterange: '1M', 
  series: [{
    name: "Data",
    data: [] // Initially empty, will be populated with data for each timestamp
  }],
  chartOptions: {
    chart: {
      height: 350,
      type: 'line',
      animations: {
        enabled: false,
        easing: 'easeinout',
        speed: 800,
        animateGradually: {
          enabled: false,
          delay: 150
        },
        dynamicAnimation: {
          enabled: false,
          speed: 350
        }
      },
      zoom: {
        enabled: false
      },
      toolbar: {
        show: false // Disables the toolbar
      },
    },

    dataLabels: {
      enabled: false
    },
    stroke: {
      show: true,
      curve: 'smooth',
      lineCap: 'butt',
      colors: undefined,
      width: 2,
      dashArray: 0,
    },
    grid: {
      row: {
        colors: ['#FFFFFF', 'transparent'],
        opacity: 0.5
      },
    },
    xaxis: {
      categories: [],
      tickAmount: 125,
      labels: {
        rotateAlways: true,
        rotate: -45
      },
      offsetY: 5,

      tooltip: {
        enabled: false // Disable tooltip for x-axis
      } // Will be populated with timestamps
    }
  },
  selectedMoistureOption: 1,
  sData: {},
  roots:[],
  folders:[],
  hubs: [],
  components: [],
  devices: [],
  files:[],
  Moistures: [
    { name: 0.5 },
    { name: 1.0 },
    { name: 1.5 },
    { name: 2.0 },
    { name: 2.5 },
    { name: 3.0 }
  ],
}
},
async mounted() {

await this.getddRoot()
},


methods: {
async getddRoot() {
  try {
    let data = []
    data = await ddRoot();
    const response = await data;
    this.selectedRoot = '';
    this.roots = response
  } catch (error) {
    this.error = error.message; // Set the error message
    console.error('Error fetching report hubs:', error);
  }
},

async getddFolder() {
    try {
      let data = []
      data = await ddFolder({root:this.selectedRoot});
      const response = await data;
      if (!response || response.length === 0) {
    this.folders = [];
    this.selectedFolder = ''; // or set to a default value if you prefer
  } else {
      if (!response.find(fold => fold.folder === this.selectedFolder)) {
        this.selectedFolder = '';
  }
      this.folders = response
}
    } catch (error) {
      this.error = error.message; // Set the error message
      console.error('Error fetching Component :', error);
    }


  },
  
  async getddFile() {
    try {
      let data = []
      data = await ddFile({root:this.selectedRoot, folder: this.selectedFolder});
      const response = await data;
      if (!response || response.length === 0) {
    this.files = [];
    this.selectedFile = ''; // or set to a default value if you prefer
  } else {
      if (!response.find(fl => fl.filename === this.selectedFile)) {
        this.selectedFile = '';
  }
      this.files = response
}
    } catch (error) {
      this.error = error.message; // Set the error message
      console.error('Error fetching Component :', error);
    }


  },
  
  async getddHub() {
    try {
      let data = []
      data = await ddHub();
      const response = await data;
       this.hubs = response;
    } catch (error) {
      this.error = error.message; // Set the error message
      console.error('Error fetching Component :', error);
    }
  },
  
  async getddComponent() {
    try {
    let data = []
    let payload = {
      hub: this.selectedHub,
    };
        if (!this.isDateRangeChecked) {
      payload.root = this.selectedRoot;
      payload.folder = this.selectedFolder;
      payload.filename = this.selectedFile;
    }
      data = await ddController(payload);
      const response = await data;
      if (!response || response.length === 0) {
    this.components = [];
    this.selectedController = ''; // or set to a default value if you prefer
  } else {
      if (!response.find(comp => comp.uuid === this.selectedController)) {
        this.selectedController = '';
  }
      this.components = response
}
    } catch (error) {
      this.error = error.message; // Set the error message
      console.error('Error fetching Component :', error);
    }


  },
  
  async getddDevices() {
    try {
    let data = []
     let payload = {
      hub: this.selectedHub,
      controller: this.selectedController,
    };
     if (!this.isDateRangeChecked) {
      payload.root = this.selectedRoot;
      payload.folder = this.selectedFolder;
      payload.filename = this.selectedFile;
    }
      data = await ddDevice(payload);
      const response = await data;
      if (!response || response.length === 0) {
    this.devices = [];
    this.selectedDevice = ''; // or set to a default value if you prefer
  } else {
      if (!response.find(device => device.uuid === this.selectedDevice)) {
        this.selectedDevice = '';
  }
      this.devices = response

   }
    } catch (error) {
      this.error = error.message; // Set the error message
      console.error('Error fetching Component :', error);
    }


  },



async fetchGraphData() {
  try {
    if (this.isTimer == 0) {
      this.loading = true;
      this.series[0].data = [];
    }

    const payload = {};
    if(!this.isDateRangeChecked){
      payload.root = this.selectedRoot,
      payload.folder = this.selectedFolder,
      payload.filename = this.selectedFile,
      payload.hub = this.selectedHub,
      payload.controller = this.selectedController,
      payload.device = this.selectedDevice
    } else if (this.isDateRangeChecked){
      payload.hub = this.selectedHub,
      payload.controller = this.selectedController,
      payload.device = this.selectedDevice,
      payload.startdate = this.startdate,
      payload.daterange = this.daterange
    }

    // Include or exclude "moisture" parameter based on the selected option
    if (this.selectedMoistureOption === 0) {
      payload.moisture = parseFloat(this.selectedMoisture);
    }
    const monthRange = [];
      const monthYearArray = [];
      // const srData = [];
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const seriesData = [];
      const xaxisCategories = [];
      // let started = false;
      if(!this.isDateRangeChecked){
        const response = await getDeviceGraphData(payload);
        if (!response || !response.data || response.data.length === 0) {
          this.noRecordFound = "No Record Found";
        } else if (response || response.data || response.data.length >0){
          this.noRecordFound = '';
        }
        let firstRecordDate = new Date(response.data[0].timestamp);
        let month = firstRecordDate.toLocaleString('default', { month: 'short', timeZone: 'UTC' });
        let year = firstRecordDate.getUTCFullYear();
        let daysInMonth = new Date(year, firstRecordDate.getUTCMonth() + 1, 0).getDate();
        for (let day = 1; day <= daysInMonth; day++) {
        monthRange.push(`${month} ${day}`);
        }
    let monthDataMap = {};

// Process the data into the monthDataMap
response.data.forEach(item => {
    let date = new Date(item.timestamp);
    let monthKey = `${date.toLocaleString('default', { month: 'short', timeZone: 'UTC' })} ${date.getUTCDate()}`;
    if (!monthDataMap[monthKey]) {
        monthDataMap[monthKey] = {
            seriesData: [item.start, item.low, item.high, item.end],
            xaxisCategories: [monthKey, '', '', '']
        };
    }
});
// Populate the series data and xaxis categories based on month range
monthRange.forEach(element => {
    if (monthDataMap[element]) {
        seriesData.push(...monthDataMap[element].seriesData);
        xaxisCategories.push(...monthDataMap[element].xaxisCategories);
    } else {
        // Handle case where no data exists for the specific day
        seriesData.push(null, null, null, null);
        xaxisCategories.push(element, '', '', '');
    }
});
      this.series[0].data = seriesData;
      const updatedOptions = { ...this.chartOptions };
      updatedOptions.xaxis.categories = xaxisCategories;
      this.chartOptions = updatedOptions;

      } else if(this.isDateRangeChecked){
        if(this.daterange == "1M"){
    const currentDate = new Date(this.startdate);  // Current date
    const currentMonth = currentDate.getMonth();  // Current month (0-indexed)
    const currentYear = currentDate.getFullYear();  // Current year
    const currentDayOfMonth = currentDate.getDate();  // Current day of the month

    // Set the end date to be 30 days ahead from the current date
    const nextMonthDate = new Date(currentDate);
    nextMonthDate.setDate(currentDate.getDate() + 30);  // Adds 30 days

    let monthRange = [];

    // Loop over each day from current date to the next 30 days
    for (let date = new Date(currentYear, currentMonth, currentDayOfMonth); 
        date <= nextMonthDate; 
        date.setDate(date.getDate() + 1)) {
        
        const formattedDate = `${monthNames[date.getMonth()]} ${date.getDate()}`;
        monthRange.push(formattedDate);  // Add formatted date to the range
    }

    // Fetch data
    const response = await getDeviceGraphData(payload);
    this.currentFlowRate = response.flowrate;

    if (!response || !response.data || response.data.length === 0) {
          this.noRecordFound = "No Record Found";
        } else if (response || response.data || response.data.length >0){
          this.noRecordFound = '';
        }

    let seriesData = [];
    let xaxisCategories = [];

    let monthDataMap = {};

    // Process the data into the monthDataMap
    response.data.forEach(item => {
        let date = new Date(item.timestamp);
        let monthKey = `${date.toLocaleString('default', { month: 'short', timeZone: 'UTC' })} ${date.getUTCDate()}`;
        if (!monthDataMap[monthKey]) {
            monthDataMap[monthKey] = {
                seriesData: [item.start, item.low, item.high, item.end],
                xaxisCategories: [monthKey, '', '', '']
            };
        }
    });

    // Populate the series data and xaxis categories based on month range
    monthRange.forEach(element => {
        if (monthDataMap[element]) {
            seriesData.push(...monthDataMap[element].seriesData);
            xaxisCategories.push(...monthDataMap[element].xaxisCategories);
        } else {
            // Handle case where no data exists for the specific day
            seriesData.push(null, null, null, null);
            xaxisCategories.push(element, '', '', '');
        }
    });

    this.series[0].data = seriesData;  // Assign the processed data to the chart
    const updatedOptions = { ...this.chartOptions };
    updatedOptions.xaxis.categories = xaxisCategories;  // Update xaxis categories
    this.chartOptions = updatedOptions;  // Apply the updated chart options
       } else if(this.daterange == "3M"){

    const response = await getDeviceGraphData(payload);
    this.currentFlowRate = response.flowrate;

    if (!response || !response.data || response.data.length === 0) {
          this.noRecordFound = "No Record Found";
        } else if (response || response.data || response.data.length >0){
          this.noRecordFound = '';
        }

    let seriesData = [];
    let xaxisCategories = [];

    response.data.forEach(item => {
      let date = new Date(item.timestamp);
      let monthKey = `${date.toLocaleString('default', { month: 'short', timeZone: 'UTC' })} ${date.getUTCDate()}`;
      if (item.sensorid === "") {
            // Set start, low, high, and end values to null if sensorid is empty
            seriesData.push(null, null, null, null);
        } else {
            // Otherwise, use the actual values
            seriesData.push(item.start, item.low, item.high, item.end);
        }
            xaxisCategories.push(monthKey, '', '', '');
    });

    this.series[0].data = seriesData;  // Assign the processed data to the chart
    const updatedOptions = { ...this.chartOptions };
    updatedOptions.xaxis.categories = xaxisCategories;  // Update xaxis categories
    this.chartOptions = updatedOptions;  // Apply the updated chart options
} else if(this.daterange == "6M"){
   
    const response = await getDeviceGraphData(payload);
    this.currentFlowRate = response.flowrate;

    if (!response || !response.data || response.data.length === 0) {
          this.noRecordFound = "No Record Found";
        } else if (response || response.data || response.data.length >0){
          this.noRecordFound = '';
        }
        
    let seriesData = [];
    let xaxisCategories = [];
    response.data.forEach(item => {
      let date = new Date(item.timestamp);
      let monthKey = `${date.toLocaleString('default', { month: 'short', timeZone: 'UTC' })} ${date.getUTCDate()}`;
      if (item.sensorid === "") {
            // Set start, low, high, and end values to null if sensorid is empty
            seriesData.push(null, null, null, null);
        } else {
            // Otherwise, use the actual values
            seriesData.push(item.start, item.low, item.high, item.end);
        }
            xaxisCategories.push(monthKey, '', '', '');
    });

    this.series[0].data = seriesData;  // Assign the processed data to the chart
    const updatedOptions = { ...this.chartOptions };
    updatedOptions.xaxis.categories = xaxisCategories;  // Update xaxis categories
    this.chartOptions = updatedOptions;  // Apply the updated chart options
}
      }
  
  } catch (error) {
    this.error = error.message;
    console.error('Error fetching device graph:', error);
  } finally {
    this.loading = false;
    this.isTimer = 0
  }



},

handleselectedMoistureOption() {
  // Fetch graph data with the updated timeframe
  // this.fetchGraphData();
  this.series[0].data = [];
   this.noRecordFound = ""
},

handleDateRangeChange(){
  if(this.isDateRangeChecked){
    this.series[0].data = [];
    this.noRecordFound = "",
    this.getddHub()
  } else if(!this.isDateRangeChecked){
    this.getddRoot();
    this.series[0].data = [];
     this.noRecordFound = "",
     this.selectedRoot = "",
     this.roots = [],
     this.selectedFolder = "",
     this.folders = [],
     this.selectedFile = "",
     this.files = [],
     this.selectedHub = "",
     this.hubs = [],
     this.selectedController = "",
     this.components = [],
     this.selectedDevice = "",
     this.devices = []
  }
},
onRootChange() {
  this.selectedFolder = '';
  this.selectedFile = '';
  this.folders = [];
  this.files = [];
   this.selectedController = '';
  this.components = [];
  this.selectedDevice = '';
  this.devices = [];
    this.selectedHub = '';
  this.hubs = [];
   this.series[0].data = [];
   this.noRecordFound = ""
  if (!this.isDateRangeChecked){
  this.getddFolder();
  }
},

onFolderChange() {
  this.selectedHub = '';
  this.hubs = [];
  this.selectedController = '';
  this.components = [];
  this.selectedDevice = '';
  this.devices = [];
  this.selectedFile = '';
  this.files = [];
   this.series[0].data = [];
   this.noRecordFound = ""
   if (!this.isDateRangeChecked){
  this.getddFile();
   }
},
onFileChange() {
  this.selectedHub = '';
  this.hubs = [];
  this.selectedController = '';
  this.components = [];
  this.selectedDevice = '';
  this.devices = [];
   this.series[0].data = [];
   this.noRecordFound = ""
   if (!this.isDateRangeChecked){
  this.getddHub();
   }
},

onHubChange() {
  this.selectedController = '';
  this.components = [];
  this.selectedDevice = '';
  this.devices = [];
   this.series[0].data = [];
   this.noRecordFound = ""
  this.getddComponent();
},

onControllerChange() {
  this.selectedDevice = '';
  this.devices = [];
   this.series[0].data = [];
   this.noRecordFound = ""
  this.getddDevices();
},
}


};
</script>
<style scoped></style>
